import { render, staticRenderFns } from "./StorageShippingUnitsConsultationShippingUnitDetail.vue?vue&type=template&id=539b7a70&scoped=true&"
import script from "./StorageShippingUnitsConsultationShippingUnitDetail.vue?vue&type=script&lang=ts&"
export * from "./StorageShippingUnitsConsultationShippingUnitDetail.vue?vue&type=script&lang=ts&"
import style0 from "./StorageShippingUnitsConsultationShippingUnitDetail.vue?vue&type=style&index=0&id=539b7a70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539b7a70",
  null
  
)

export default component.exports